import React from "react";
import { TStaticDrawFunction } from "../../../Components/Canvas";
import { MeasurementChartPainter } from "./MeasurementChartPainter";
import MeasurementChart from "./MeasurementChart";
import { IControl } from "../types";
import useControlMeasurements from "../../../hooks/useControlMeasurements";
import { useTranslation } from "react-i18next";

interface IBatteryTemperatureChartProps {
  control: IControl;
  width: number;
  height: number;
}

const BatteryTemperatureChart = (props: IBatteryTemperatureChartProps) => {
  const { control, width, height } = props;
  const { value, valuesList } = useControlMeasurements(control, ["bat_temp"]);
  const { t } = useTranslation();

  if (!valuesList) {
    return null;
  }

  const draw: TStaticDrawFunction = (ctx) => {
    const chart = new MeasurementChartPainter(width, height);
    chart.drawLines(ctx, valuesList, ["#000000"], "°C");
  };

  return (
    <MeasurementChart
      title={t("Battery Temperature") + `: ${value}°C`}
      draw={draw}
      width={width}
      height={height}
    />
  );
};

export default BatteryTemperatureChart;
